import { Link } from 'expo-router';
import React from 'react';
import { Pressable, Text } from 'react-native';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    H6Emphasized,
    Icon,
    isWeb,
    SafeAreaView,
    UserCogIcon,
    View,
    YStack,
} from 'smoothie';

import { useSendEmailToSupport } from '../../common/hooks/useSendEmailToSupport';
import { getWebUrl } from '../../lib/Web';
import { captureMessage } from '../../logger/Logger';
import { SUPPORT_EMAIL } from '../../settings/types/constants';
import { useLogout } from '../hooks/useLogout';
import { LogoutType } from '../types/Auth';

export const NoAccess = () => {
    const sendEmailToSupport = useSendEmailToSupport();
    const { logOut } = useLogout();

    captureMessage(
        `User does not have a valid membership and is trying to use the app.`,
    );

    return (
        <SafeAreaView style={{ flex: 1 }}>
            <YStack
                justifyContent={isWeb ? 'flex-start' : 'space-between'}
                gap={100}
                alignItems="center"
                padding={20}
                width="100%"
                height="100%"
                $sm={{ width: 500, alignSelf: 'center' }}
            >
                <YStack marginTop={112} alignItems="center">
                    <View
                        height={110}
                        width={110}
                        justifyContent="center"
                        alignItems="center"
                        backgroundColor="$gray100"
                        padding={25}
                        borderRadius={25}
                    >
                        <Icon icon={UserCogIcon} size={60} color="$gray1200" />
                    </View>
                    <H6Emphasized marginTop={40}>Access issue</H6Emphasized>
                    <BodyMediumRegular
                        marginTop={12}
                        maxWidth={250}
                        textAlign="center"
                        $sm={{ maxWidth: 400 }}
                    >
                        {isWeb ? (
                            <>
                                Based on your membership status, you may not be
                                able to access the Fruitful app. Please contact
                                our Hospitality team for support at{' '}
                                {SUPPORT_EMAIL}.
                            </>
                        ) : (
                            <>
                                Based on your membership status, you may not be
                                able to access the Fruitful app. You can try
                                again at{' '}
                                <Link href={getWebUrl()} asChild>
                                    <Pressable>
                                        <Text
                                            style={{
                                                color: '#0000FF',
                                                textDecorationLine: 'underline',
                                            }}
                                        >
                                            my.fruitful.com
                                        </Text>
                                    </Pressable>
                                </Link>{' '}
                                or contact our Hospitality team for support.
                            </>
                        )}
                    </BodyMediumRegular>
                </YStack>
                <YStack width="100%" gap={16}>
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        text="Contact Fruitful Hospitality"
                        onPress={() => {
                            void sendEmailToSupport();
                        }}
                        buttonProps={{
                            testID: 'access-issue-contact-hd-button',
                        }}
                    />
                    <Button
                        variant={ButtonVariant.SECONDARY}
                        size={ButtonSize.LARGE}
                        text="Sign out"
                        onPress={() => {
                            void logOut(LogoutType.NoAccessScreenButton);
                        }}
                    />
                </YStack>
            </YStack>
        </SafeAreaView>
    );
};
